import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./modules/global/global.module').then((m) => m.GlobalModule),
  },
  {
    path: 'service',
    loadChildren: () =>
      import('./modules/service/service.module').then((m) => m.ServiceModule),
  },
  {
    path: 'admin/topup',
    loadChildren: () =>
      import('./modules/admin/topup/topup.module').then((m) => m.TopupModule),
  },
  {
    path: 'account/signin',
    loadChildren: () =>
      import('./modules/account/signin/signin.module').then(
        (m) => m.SigninModule
      ),
  },
  {
    path: 'account/signup',
    loadChildren: () =>
      import('./modules/account/signup/signup.module').then(
        (m) => m.SignupModule
      ),
  },
  {
    path: 'account/reset',
    loadChildren: () =>
      import('./modules/account/reset/reset.module').then((m) => m.ResetModule),
  },
  {
    path: 'comming-soon',
    loadChildren: () =>
      import('./modules/comming-soon/comming-soon.module').then(
        (m) => m.CommingSoonModule
      ),
  },
  {
    path: 'profile/complete',
    loadChildren: () =>
      import('./modules/profile/complete/complete.module').then(
        (m) => m.CompleteModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
